import styled from 'styled-components';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import Button from '@paradigm/design-system/src/components/Button';
import { Side } from '@paradigm/features/src/unified-rfqs/entities/shared';

export const ActionButton = styled(Button).attrs((props: { side?: Side }) => ({
  ...props,
  bold: true,
  theme: props.side === 'SELL' ? 'secondary-red' : 'secondary-green',
  size: 'small',
}))<{ side?: Side }>`
  width: 50px;
  text-transform: capitalize;
  white-space: nowrap;

  &:disabled {
    opacity: 0.5;
    color: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    font-size: 15px;
    width: 60px;
    height: 26px;
  }
`;
